import React, { useState, useRef, useEffect } from 'react';
import Notification from '../../components/Notification';
import ChangePassword from '../../components/ChangePassword';
import EditAccountDetails from '../../components/EditAccountDetails';
import useApi from '../../api/useApi';
import { useStateValue } from '../../ContextApi/StateProvider';
import { roles } from '../../Constants';

function Account() {
  const [{ user }, dispatch] = useStateValue();

  // const { user } = JSON.parse(localStorage.user);

  const [notification, setNotification] = useState(false);
  const [type, setType] = useState(null);
  const [message, setMessage] = useState(null);
  const [selectedImg, setImage] = useState();
  const [selectedImgFile, selectImage] = useState();
  const [{ isLoading, isError, data }, updateImage] = useApi();
  const [state, getUpdatedUserDetails] = useApi();
  const [edit, setEdit] = useState(false);
  const [changePassword, setChangePassword] = useState(false);
  const image = useRef();

  const showNotification = (typ, msg) => {
    setType(typ);
    setMessage(msg);
    setNotification(true);
  };

  const alertMsg = (msg) => {
    setNotification(msg);
  };

  const getRole = (roleCode) => {
    const x = roles.filter((role) => role.id == roleCode);
    return x[0].value;
  };

  const toggleEditOption = () => {
    setEdit((prev) => !prev);
  };

  const toggleChangePaasword = () => {
    setChangePassword((prev) => !prev);
  };

  const fileChangedHandler = (event) => {
    const extention = event.target.files[0].name.split('.')[1];
    const validExtentions = ['JPG', 'JPEG', 'PNG', 'SVG'];
    if (!validExtentions.includes(extention.toUpperCase())) {
      setType('error');
      setMessage('You can upload only JPG JPEG PNG and SVG files');
      setNotification(true);
      return;
    }

    selectImage(event.target.files[0]);

    const reader = new FileReader();
    reader.onload = (e) => {
      setImage(e.target.result);
    };
    reader.readAsDataURL(event.target.files[0]);
  };

  const uploadAvatar = () => {
    if (selectedImgFile) {
      const formData = new FormData();
      formData.append('file', selectedImgFile, selectedImgFile.name);

      updateImage(`/user/${user.userId}/avatar`, 'POST', formData);
    }
  };

  useEffect(() => {
    if (!isLoading && !isError && data) {
      setType('success');
      setMessage('User Details updated Successfully');
      setNotification(true);

      setTimeout(() => {
        getUpdatedUserDetails(`/user/${user.userId}`, 'get');
      }, 4000);
    }
    if (isError) {
      setType('error');
      setMessage('Unable to update user Details');
      setNotification(true);
    }
  }, [isLoading, isError, data]);

  useEffect(() => {
    if (!state.isLoading && !state.isError && state.data) {
      const x = {
        ...JSON.parse(localStorage.user),
        ...state.data,
      };
      dispatch({
        type: 'USER_DATA',
        user: state.data.user,
      });
      localStorage.user = JSON.stringify(x);
    }
  }, [state]);

  return (
    <>
      {notification && <Notification type={type} message={message} alertMsg={alertMsg} />}
      {
        changePassword && <div
        className="flex justify-center items-center h-full w-full fixed z-20"
        style={{ background: 'linear-gradient(rgba(0, 0, 0, 0.5),   rgba(0, 0, 0, 0.5))' }}
      >
        <div className="bg-white w-3/12 px-2 text-sm block m-auto rounded-2xl relative">
          <span className="block p-4 font-bold border-b text-lg text-textBlue1">Change Password</span>
          <img
            src="assets/img/Close.svg"
            className="absolute top-3 right-3 h-3 cursor-pointer"
            alt=""
            onClick={() => setChangePassword(false)}
          />
          <ChangePassword showNotification={showNotification} handleClose={toggleChangePaasword}/>
          {/* <span className="block text-center text-sm my-8" style={{ color: '#9B9B9B' }}>
            Do you want to delete project
          </span>
          <div className="mb-6 ml-24 font-bold w-full">
            <div className="w-1/3" />
            <div className="w-2/3 flex">
              <button
                type="submit"
                className="mt-1 lg:mt-0 lg:w-max border px-8 py-4 rounded-3xl text-xs mr-2 focus:outline-none flex justify-center items-center h-7"
                onClick={() => {
                  setChangePassword(false);
                }}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="mt-1 lg:mt-0 w-full lg:w-max border px-8 py-4 rounded-3xl text-xs font-bold focus:outline-none flex justify-center items-center h-7 bg-btnBg text-white"
                // onClick={handleDelete}
              >
                Confirm
              </button>
            </div>
          </div> */}
        </div>
      </div>
      }
      <div className="h-auto w-2/4 border absolute hideScroll justify-center items-center bg-white" style={{ left: '34%', top: '16%' }}>
        <div className="w-full">
          <div className=" block px-4 py-4 bg-primary text-white text-xs relative">
            <span>My Profile</span>
            { !edit && <img src="assets/img/Edit_White.svg" className="h-4 absolute right-36 top-4" alt="" onClick={() => {
              setEdit(true);
            }}/> }
            <button type="submit" className="float-right border absolute right-4 px-3 p-1 top-3 rounded-2xl border-white" onClick={() => {
              setChangePassword(true);
            }}>
              Change Password
            </button>
          </div>
          <div className="m-12 text-xs">
          <div className="h-24 flex">
              {/* <div className="w-1/4 flex items-center justify-start"> */}
              <img
                src={selectedImg || `${user.avatar}?${global.Date.now()}` || 'assets/img/placeholder.jpg'}
                alt=""
                className="rounded-md h-24 w-24"
              />
              {edit && <img src="assets/img/editImage.svg" className="h-6 -ml-6 -mt-1" onClick={() => image.current.click()} />}
              <input hidden ref={image} type="file" onChange={fileChangedHandler} />
            </div>
            <p className="mt-5 w-full text-sm font-bold">General Information</p>
            { !edit && <div>
            <div className="flex w-full mt-6">
              <div className="w-3/5">
                <span className="text-gray-400">First Name</span>
                <p className='mt-2'>{user.userName.split(' ')[0]}</p>
              </div>
              <div className="w-2/5">
                <span className="text-gray-400">Last Name</span>
                <p className='mt-2'>{user.userName.split(' ')[1]}</p>
              </div>
            </div>

            <div className="flex w-full mt-10">
              <div className="w-3/5">
                <span className="text-gray-400">Short Name</span>
                <p className='mt-2 capitalize'>{user.slug}</p>
              </div>
              <div className="w-2/5">
                <span className="text-gray-400">Email</span>
                <p className='mt-2'>{user.email}</p>
              </div>
            </div>
            <div className="flex w-full mt-10">
              <div className="w-3/5">
                <span className="text-gray-400">Phone Number</span>
                <p className='mt-2'>{user.contact}</p>
              </div>
              <div className="w-2/5">
                <span className="text-gray-400">Role</span>
                <p className='mt-2'>{ getRole(user.role) }</p>
              </div>
            </div>
            </div>
            }
            {
              edit && <div className="w-full">
              <EditAccountDetails showNotification={showNotification} handleClose={toggleEditOption} upDateAvatar={uploadAvatar} user={user} />
              {/* <hr className="mt-8 bg-white" /> */}
              {/* <ChangePassword showNotification={showNotification} /> */}
              </div>
            }
          </div>
        </div>
        {/* <div className="z-50" style={{ height: '22vh', paddingBottom: '4vh' }}>
          <div
            className="lg:flex block sm:block justify-between text-center lg:text-left w-tableWidth m-auto "
            style={{ paddingTop: '4vh' }}
          >
            <span className="text-textBlue1 font-bold text-xl">Account Settings</span>
          </div>
        </div> */}
        {/* {
          edit &&
          <div className="h-full mt-16">
            <div className="w-3/5 flex m-auto pb-5">
              <div className="block text-right">
                <span>My Profile</span>
              </div>
              <div className="flex">
                <div className="w-1/4 flex items-center justify-start">
                  <img
                    src={selectedImg || `${user.avatar}?${global.Date.now()}` || 'assets/img/placeholder.jpg'}
                    alt=""
                    className="rounded-full"
                    style={{ marginTop: '6.5rem', height: '8.5rem', width: '8.5rem' }}
                  />
                  <button
                    className="rounded-lg mt-9 focus:outline-none px-4 h-10 text-textBlue1 cursor-pointer"
                    style={{ background: '#16406D33', border: '1px solid #16406D' }}
                    onClick={() => image.current.click()}
                  >
                    Upload Avatar
                  </button>
                  <input hidden ref={image} type="file" onChange={fileChangedHandler} />
                </div>

                <div className="w-3/4 p-4">
                  <EditAccountDetails showNotification={showNotification} upDateAvatar={uploadAvatar} user={user} />
                  <hr className="mt-8 bg-white" />
                  <ChangePassword showNotification={showNotification} />
                </div>
              </div>
            </div>
          </div>
        } */}

      </div>
    </>
  );
}

export default Account;
